import firebase from "firebase";
import {
	CHANGE_PROPS_RECOVERY_PASSWORD,
	CHANGE_APP_PROPS
} from "./ActionConstants";
import AuthService from "../provider/auth/AuthService";
import { sessionService } from "redux-react-session";
import APIConnector from "../provider/base/APIConnector";
import confirmEmailService from "../provider/confirmEmail/confirmEmailService";

export function login(user, pass, successCalback, errorCallback) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		AuthService.login(user, pass)
			.then(function(respLogin) {
				let tokenHeader = "Bearer ";
				tokenHeader += respLogin.token;
				APIConnector.defaultHeaders.Authorization = tokenHeader;
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						rol: respLogin.rol[0].rol,
						loading: false,
						username: respLogin.email,
						confirmEmail: false,
						firebaseToken: respLogin.firebaseToken
					}
				});
				sessionService.saveSession(respLogin);
				if (successCalback) {
					successCalback(respLogin);
				}
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
				errorCallback(err.message);
			});
	};
}

export function saveUser(value) {
	return () => {
		const { email } = value;
		sessionService.saveUser(email);
	};
}

//Para logOut hacer:
export function actionLogOut(callback) {
	return dispatch => {
		AuthService.logout();
		sessionService.deleteUser();
		sessionService.deleteSession();
		var user = firebase.auth().currentUser;
		if (user) firebase.auth().signOut();
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				rol: "",
				username: "",
				loading: false
			}
		});
		callback();
	};
}

export function forgotPassword(email, callback) {
	return (dispatch, getStore) => {
		AuthService.forgotPassword(email)
			.then(function(resp) {
				callback(true);
			})
			.catch(function(error) {
				callback(false);
			});
	};
}

export function reSendEmailConfirm(email, callback) {
	return (dispatch, getStore) => {
		AuthService.reSendEmailConfirm(email)
			.then(function(resp) {
				callback(true);
			})
			.catch(function(error) {
				callback(false);
			});
	};
}

export function confirmPasswordReset(code, password, callback) {
	return (dispatch, getStore) => {
		AuthService.confirmPasswordReset(code, password)
			.then(function(resp) {
				callback(true, resp);
			})
			.catch(function(error) {
				callback(false, error);
			});
	};
}

export function actionChangeRecoveryPasswordProps(props) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_PROPS_RECOVERY_PASSWORD,
			props: props
		});
	};
}

export function confirmEmail(token, success) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		confirmEmailService
			.confirmEmail(token)
			.then(resp => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						confirmEmail: true
					}
				});
				success();
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js